module.exports = __webpack_public_path__ + "static/media/binance_logo.3806f2cc.png";